<template>
  <div id="map-controls-sidebar-vessel-equipment-base-stations">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeVesselEquipmentBaseStationSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">資機材運搬管理</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="
              SET_ACTIVE_VESSEL_EQUIPMENT_BASE_STATION_SIDEBAR(false)
            "
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" color="#828282" />
        <vessel-equipment-base-stations :settings="settings" :map="map" />
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
/**
 * LiveMapの作業船位置メニューと検索フォームを描画するコンポーネント
 * @parent MapControlsSidebar
 * @props map: Object マップのインスタンスデータ
 */
import VesselEquipmentBaseStations from "@/components/organisms/VesselEquipmentBaseStations";
import { createNamespacedHelpers } from "vuex";
const { mapState: mapStateOfLiveMap, mapMutations: mapMutationsOfLiveMap } =
  createNamespacedHelpers("liveMap");
export default {
  name: "O.SidebarVesselEquipmentBaseStations",
  components: {
    VesselEquipmentBaseStations,
  },
  data() {
    return {
      /** スクロールの設定 */
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  props: {
    map: Object,
  },
  computed: {
    ...mapStateOfLiveMap({
      activeVesselEquipmentBaseStationSidebar: (state) =>
        state.activeVesselEquipmentBaseStationSidebar,
    }),
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_VESSEL_EQUIPMENT_BASE_STATION_SIDEBAR",
    ]),
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
#map-controls-sidebar-vessel-equipment-base-stations {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }
}
</style>
